import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

//pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//    'pdfjs-dist/build/pdf.worker.min.mjs',
//    import.meta.url,
//).toString();

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
